import { Component, Input, inject } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataService } from '../../../services/data.service';
import { ApplicationFormComponent } from '../application-form/application-form.component';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-application-list',
	imports: [CommonModule, FormsModule, ApplicationFormComponent],
	providers: [DatePipe],
	templateUrl: './application-list.component.html',
	styleUrl: './application-list.component.scss',
})
export class ApplicationListComponent {
	@Input() action: any;
  datePipe = inject(DatePipe);
	dataService = inject(DataService);
  auth = inject(AuthService);
  user: any = null;

	base = 'applications';		// important for API calls
  btnClick: string = "";
  loading = false;
  isEdit = false;
	allData: any = [];
  orgData: any = [];
  appData: any = null;
  searchTerm: string = '';

  tblFields: any = [
    {"field": "inq_code",	"title": "Inq. Code"},
    {"field": "app_code",	"title": "App. Code"},
    {"field": "std_name",	"title": "Std. Name"},
    {"field": "std_dob"	,	"title": "Std. DOB"},
    {"field": "std_info",	"title": "Other Info."},
    {"field": "father_name",	"title": "Father Name"},
    {"field": "f_info",	"title": "Other Info"},
    {"field": "mother_name",	"title": "Mother Name"},
    {"field": "m_info",	"title": "Other Info"},
    {"field": "guardian_name",	"title": "Guardian Name"},
    {"field": "g_info",	"title": "Other Info"},
    {"field": "addresses",	"title": "Addresses"},
    {"field": "academics",	"title": "Academics"},
    {"field": "documents",	"title": "Documents"},
    {"field": "req_transport",	"title": "Req. Transport"},
    {"field": "req_hostel",	"title": "Req. Hostel"},
    {"field": "reg_date",	"title": "Reg. Date"},
    {"field": "is_active",	"title": "Is Active"},
    {"field": "is_eligible",	"title": "Is Eligible"},
    {"field": "declaration",	"title": "Declaration"}
  ];
  
  ngOnInit() {
    let erp_rem: any = localStorage.getItem("erp_rem");
    if(erp_rem) {
      erp_rem = JSON.parse(erp_rem);
      erp_rem = this.dataService.deCodeUser(erp_rem);
      this.user = erp_rem;
    }

    // Listen to changes continuously
    this.dataService.outerAction.subscribe((value: any) => {
      if (value) {
        this.action = value.action;
        if(this.action && this.action=='reload') {
          this.ngOnInit();
        }
      }
    });

    this.loading = true;
    this.dataService.getAllRecords(this.base).then((res: any) => {
      this.allData = res;
      this.orgData = Object.assign([], res);
      this.loading = false;
    });
	}

	ngOnChanges() {
		if(this.action && this.action=='reload') {
			this.ngOnInit();
		}
	}

  newClick() {
    this.isEdit = false;
    this.btnClick = 'addnew';
    this.dataService.updateOuterAction({
      component: 'application',
      action: 'addnew', data: null
    });
  }

  reloadData() {
    setTimeout(()=>{
      this.ngOnInit();
    }, 1000);
  }

  editClick(myData: any) {
    this.isEdit = true;
    this.btnClick = 'modify';
    this.dataService.updateOuterAction({
      component: 'application',
      action: 'edit', data: myData
    });
  }

  getEditData(frmData: any) {
    if(frmData.std_info && typeof frmData.std_info == 'string') {
      frmData.std_info = JSON.parse(frmData.std_info);
    }
    
    if(frmData.f_info && typeof frmData.f_info == 'string') {
      frmData.f_info = JSON.parse(frmData.f_info);
    }

    if(frmData.m_info && typeof frmData.m_info == 'string') {
      frmData.m_info = JSON.parse(frmData.m_info);
    }

    if(frmData.g_info && typeof frmData.g_info == 'string') {
      frmData.g_info = JSON.parse(frmData.g_info);
    }

    if(frmData.additional && typeof frmData.additional == 'string') {
      frmData.additional = JSON.parse(frmData.additional);
    }

    if(frmData.declaration && typeof frmData.declaration == 'string') {
      frmData.declaration = JSON.parse(frmData.declaration);
    }

    if(frmData.academics && typeof frmData.academics == 'string') {
      frmData.academics = JSON.parse(frmData.academics);
    }

    if(frmData.subjects && typeof frmData.subjects == 'string') {
      frmData.subjects = JSON.parse(frmData.subjects);
    }

    if(frmData.addresses && typeof frmData.addresses == 'string') {
      frmData.addresses = this.dataService.str2json(frmData.addresses);
    }
    
    if(frmData.documents && typeof frmData.documents == 'string') {
      frmData.documents = this.dataService.str2json(frmData.documents);
    }

    this.appData = frmData;
  }

  onSearchChange(): void {
    const query = this.searchTerm.trim().toLowerCase();

    if (!query) {
      this.allData = [...this.orgData];
      return;
    }

    this.allData = this.orgData.filter((user: any) => this.deepMatch(user, query));
  }

  private deepMatch(value: any, query: string): boolean {
    if (value === null || value === undefined) {
      return false;
    }

    if (typeof value === 'object') {
      return Object.values(value).some(nestedValue => this.deepMatch(nestedValue, query));
    }

    return String(value).toLowerCase().includes(query);
  }

	async deleteClick(myid: number) {
    const confirmed = await this.dataService.confirmDelete();
    if (confirmed) {
        console.log('Item deleted successfully');
				this.doDelete(myid);
    } else {
        console.log('Deletion cancelled');
    }
	}

  doDelete(myid: number) {
		this.loading = true;
    this.dataService.deleteRecord(this.base, myid).subscribe({
      next: (response) => {
        console.log('Response received in component:', response);
        // You can handle your loading states or form resets here:
        this.loading = false;
        this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
	}

}
